// Copyright 2026 UBC Quantum Software and Algorithms Research Lab

// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at

//     http://www.apache.org/licenses/LICENSE-2.0

// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { memo } from "react";
import PropertyList from "./PropertyList";
import PostselectOverride from "./PostselectOverride";

const SidePanel = ({ show, selectedNode, isDebuggerActive, onPostSelectApply, postSelectSuccess, overlayButtonStyle, setSelectedNodeId }) => {
    if (!show || !selectedNode) return null;

    return (
        <div style={{ position: "absolute", top: 16, right: 16, background: "#1a1a1a", border: "1px solid #444", borderRadius: "10px", padding: "16px", width: "250px", color: "#eee", fontSize: "13px", zIndex: 10, maxHeight: "80%", overflowY: "auto", transition: "all 0.2s ease-in-out", boxShadow: postSelectSuccess ? "0 0 15px rgba(167, 139, 250, 0.5)" : "none" }}>
            <div style={{ fontWeight: "bold", marginBottom: "10px", color: selectedNode.is_mid_measure ? "#e066ff" : "#4a9eff" }}>{selectedNode.tree_node_name}</div>

            <PropertyList node={selectedNode} />

            {selectedNode.is_mid_measure && isDebuggerActive && (
                <div>
                    <p style={{ color: "#e066ff" }}>Cannot change post-selection while debugger is active.</p>
                </div>
            )}
            {selectedNode.is_mid_measure && !isDebuggerActive && (
                <PostselectOverride selectedNode={selectedNode} onPostSelectApply={onPostSelectApply} />
            )}

            <button onClick={() => setSelectedNodeId(null)} style={{ ...overlayButtonStyle, marginTop: "10px" }}>✕ Close</button>
        </div>
    );
};

export default memo(SidePanel);